module.exports = __webpack_public_path__ + "06102bdcae6b1096d5e465ef39d59bef.MP3";